import $ from 'jquery';
import {Chart} from "chart.js";
import {ScatterController,ChartTypeRegistry} from 'chart.js';


var chapterChart = null;
var questionCharts = [];


export function initCharts() {


    $(".download-stats-xls").on("click", function (e) {
        var $this = $(this);
        e.preventDefault();

        var xls_success = function (data) {
            window.open(data.url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        };
        var scan_type = $this.attr("data-scan_type");
        $.ajax({
            url: zmp_ajax.ajaxurl, method: "POST", data: {
                action: "zmpzt_" + scan_type + "_get_stats_xls",
                zmp_stats_wpnonce: $("input[name='zmp_stats_wpnonce']").val(),
                _wp_http_referer: $("input[name='_wp_http_referer']").val(),
                scan_id: $this.attr("data-scanid")
            }, dataType: "json", success: xls_success
        });
    });

    $(".persona-scan-stats .download-stats-pdf").on("click", function (e) {
        var $this = $(this);
        e.preventDefault();

        var xls_success = function (data) {
            window.open(data.url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        };
        var scan_type = $this.attr("data-scan_type");
        $.ajax({
            url: zmp_ajax.ajaxurl, method: "POST", data: {
                action: "zmpzt_" + scan_type + "_get_stats_pdf",
                zmp_stats_wpnonce: $("input[name='zmp_stats_wpnonce']").val(),
                _wp_http_referer: $("input[name='_wp_http_referer']").val(),
                scan_id: $this.attr("data-scanid"),
                function_filter: $this.attr('data-function_filter'),
                sector_filter: $this.attr('data-sector_filter')
            }, dataType: "json", success: xls_success
        });
    });

    if ($(".manager-scan-report").length > 0) {
        var chart = renderManagerScanChart(myData, benchmarkData);

        if ($(".manager-scan-report").hasClass("has-filter")) {

            var filter = function (f, s) {
                var _s = s;
                var _f = f;

                if (chart.config.data && chart.config.data.datasets) {
                    chart.config.data.datasets[0].data = benchmarkData.filter(function (item) {

                        return ((_s == "all" || item.s == _s) && (_f == "all" || item.f == _f)) ? true : false;

                    });
                }

                chart.update();

            };

            $("select.manager-scan-filter").on("change", function (e) {
                e.preventDefault();
                filter($("#zmpzt_function").val(), $("#zmpzt_sector").val());
            });
        }

    }

}

class MyScatter extends ScatterController {
    draw() {
        // Call bubble controller method to draw all the points
        super.draw();


        const chart = this.chart;
        const ctx = this.chart.ctx;
        const xaxis = chart.scales['x-axis-1'];
        const yaxis = chart.scales['y-axis-1'];

        ctx.font = "bold " + (xaxis.width / 20) + "px AvenirBook";
        ctx.fillStyle = "rgba(0, 0, 0, 0.05)";

        ctx.textAlign = "left";
        ctx.fillText("Digitale specialist ", 40, yaxis.top);

        ctx.textAlign = "right";
        ctx.fillText("Digitale leider", xaxis.width + 10, yaxis.top);

        ctx.textAlign = "left";
        ctx.fillText("Analoge specialist", 40, yaxis.bottom);

        ctx.textAlign = "right";
        ctx.fillText("Analoge leider", xaxis.width + 10, yaxis.bottom);
    }
}

MyScatter.id = 'derivedScatter';
MyScatter.defaults = ScatterController.defaults;

// Stores the controller so that the chart initialization routine can look it up
Chart.register(MyScatter);

declare module 'chart.js' {
    interface ChartTypeRegistry {
        derivedScatter: ChartTypeRegistry['scatter']
    }
}


function renderManagerScanChart(myData, theirData) {

    var cnv = $<HTMLCanvasElement>(".managerScanChart").get(0)!;

    Chart.defaults.font.family = "AvenirBook";
    Chart.defaults.font.size = 14;


    var chapterData: any = {
        //labels: labels,
        datasets: [{
            label: "Manager",
            data: theirData,
            backgroundColor: 'rgba(93, 35, 102,.3)',
            borderWidth: 2,
            borderColor: 'rgba(93, 35, 102,.6)'
        }]
    };

    if (myData.length > 0) {
        chapterData.datasets.unshift({
            label: "Ik",
            data: myData,
            backgroundColor: 'rgba(245, 114, 48,.3)',
            borderWidth: 2,
            pointRadius: 10,
            pointHoverRadius: 10,
            borderColor: 'rgba(245, 114, 48,1)'
        });
    }

    var chartOptions = {
        scales: {
            xAxes: {
                type: 'linear',
                position: 'bottom',
                ticks: {
                    max: 5, min: 1, stepSize: 1
                },
                gridLines: {
                    color: ['rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.8)', 'rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)']
                }
            },
            yAxes: {
                type: 'linear',
                position: 'bottom',
                ticks: {
                    max: 5, min: 1, stepSize: 1
                },
                gridLines: {
                    color: ['rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.8)', 'rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)']
                }
            }
        }
    };

    $(".manager-scan-filter.select2").select2({
        minimumResultsForSearch: -1, dropdownAutoWidth: true, dropdownParent: $('.manager-scan-report .filter')
    });

    return new Chart(cnv, {
        type: "derivedScatter", data: chapterData, options: chartOptions as any
    });
}
